export const BOOKING_URL = 'https://calendly.com/appealadvantage/workflow-review';
export const CONTACT_EMAIL = 'support@appealadvantage.com';
export const BOOKING_DURATION_MINUTES = 15;
